import {useEffect, useState} from 'react';
import {Button, Modal} from '@goproblems/ui';
import {useTranslation} from 'react-i18next';

export const ConfirmModal = ({
    title,
    description,
    show: showProp = false,
    okText,
    okVariant = 'primary',
    cancelText,
    cancelVariant = 'secondary',
    onOk,
    onHide,
}: {
    name?: string;
    description?: string;
    title?: string;
    show: boolean;
    okText?: string;
    okVariant?:
        | 'primary'
        | 'secondary'
        | 'success'
        | 'danger'
        | 'warning'
        | 'info'
        | 'light'
        | 'dark'
        | 'link';
    cancelText?: string;
    cancelVariant?:
        | 'primary'
        | 'secondary'
        | 'success'
        | 'danger'
        | 'warning'
        | 'info'
        | 'light'
        | 'dark'
        | 'link';
    onOk: () => void;
    onHide?: () => void;
}) => {
    const {t} = useTranslation();
    const [show, setShow] = useState(showProp);

    const handleHide = () => {
        setShow(false);
        if (onHide) onHide();
    };
    const handleOk = () => {
        if (onOk) onOk();
    };

    useEffect(() => {
        setShow(showProp);
    }, [showProp]);

    return (
        <Modal
            className="suggested-edits-preview-modal"
            show={show}
            onHide={handleHide}
            dialogClassName="max-w-[calc(100%-1rem)] md:min-w-[640px] md:w-[fit-content]">
            <Modal.Header closeButton>
                <Modal.Title>{title ?? t('common.confirm')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {description ?? t('common.confirm_change')}
            </Modal.Body>
            <Modal.Footer>
                <Button variant={cancelVariant} onClick={handleHide}>
                    {cancelText ?? t('common.cancel')}
                </Button>
                <Button variant={okVariant} onClick={handleOk}>
                    {okText ?? t('common.ok')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
